import { RegisterAprendizWithUsuarioForm } from "@/components/forms/aprendices/RegisterAprendizWithUsuarioForm";
import { Button } from "@/shared/components/ui/button";
import DataTable from "@/components/ui/dataTable";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { getAprendizColumns } from "@/lib/columns/aprendiz.columns";
import { useAprendices } from "@/hooks/aprendices/useAprendices";
import type { Aprendiz } from "@interfaces/user.interface";
import { useState } from "react";
import { UploadExcelAprendices } from "@/components/forms/aprendices/UploadExcelAprendices";
import { Skeleton } from "@/components/ui/Skeleton";

export interface ClientesResponse {
  data: Aprendiz[];
  total: number;
}

export default function Aprendices() {
  const [openCrear, setOpenCrear] = useState(false);
  const [openCarga, setOpenCarga] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");

  const { data, isLoading, isFetching } = useAprendices(page, limit, search);

  if (isLoading) {
    return (
      <div className="space-y-2">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-6 w-80" />
        <Skeleton className="h-40 w-full" />
      </div>
    );
  }

  const createAprendizModal = (
    <Dialog open={openCrear} onOpenChange={setOpenCrear}>
      <DialogTrigger asChild>
        <Button variant="headerAction" size="sm">
          + Registrar Aprendiz
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-xl xl:max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Registrar Aprendiz</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Llena el siguiente formulario para registrar un nuevo aprendiz.
        </DialogDescription>
        <div className="py-4">
          <RegisterAprendizWithUsuarioForm
            setOpen={setOpenCrear}
            queryKey={["aprendices"]}
          />
        </div>
      </DialogContent>
    </Dialog>
  );

  const cargaMasivaModal = (
    <Dialog open={openCarga} onOpenChange={setOpenCarga}>
      <DialogTrigger asChild>
        <Button variant="headerAction" size="sm">
          Cargar archivo
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>Registrar Aprendices con Excel o CSV</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Sube un archivo .xlsx o .csv con los datos de los aprendices para realizar
          una carga masiva.
        </DialogDescription>
        <div className="py-4">
          <UploadExcelAprendices setOpen={setOpenCarga} />
        </div>
      </DialogContent>
    </Dialog>
  );

  const headerActions = (
    <div className="flex flex-col sm:flex-row gap-2">
      {createAprendizModal}
      {cargaMasivaModal}
    </div>
  );

  return (
    <section className="w-full p-3 sm:p-4 md:p-6 space-y-4 sm:space-y-6">
      <div>
        <DataTable<Aprendiz>
          columns={getAprendizColumns(["aprendices"])}
          data={data?.data ?? []}
          total={data?.total ?? 0}
          page={page}
          limit={limit}
          onPageChange={setPage}
          isLoading={isFetching}
          search={search}
          onSearchChange={(value) => {
            setPage(1);
            setSearch(value);
          }}
          headerActions={headerActions}
        />
      </div>
    </section>
  );
}
